import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const AngleRight: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 27" fill="none" {...props}>
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.15L3.027 0 16 13.5 3.027 27 0 23.85 9.946 13.5 0 3.15z"
        fill="#fff"
      />
    </svg>
  );
};

const MemoAngleRight = React.memo(AngleRight);
export default MemoAngleRight;
